import { FormGroup, ValidationErrors } from "@angular/forms";

export function getErrorData(error: any) {
  if (error) {
    return {
      message: error.message,
      stack: error.stack,
    };
  }
  return null;
}

export function formatLegalId(legalId: string) {
  const formatted = legalId?.startsWith('0') ? legalId?.slice(1) : legalId;
  return formatted?.trim();
}

export function getInvalidFields(formGroup: FormGroup, parentKey = ''): Record<string, ValidationErrors> {
  return Object.keys(formGroup.controls).reduce((acc, key) => {
    const control = formGroup.controls[key];
    const fullKey = parentKey ? `${parentKey}.${key}` : key;

    if (control instanceof FormGroup) {
      Object.assign(acc, getInvalidFields(control, fullKey));
    } else if (control.invalid && control.errors) {
      acc[fullKey] = control.errors;
    }

    return acc;
  }, {} as Record<string, ValidationErrors>);
}